<template>
  <div
    :class="[$style.banner, $style[colorType()], $style['banner__width--' + size], $style['banner__height--' + height]]"
  >
    <Icon
      :class="$style.icon"
      :name="iconName"
      :size="20"
      :fill="iconColor"
    />
    <Paragraph1 :class="$style.center">
      {{ text }}
    </Paragraph1>
  </div>
</template>

<script lang="ts" setup>
import { Paragraph1 } from '~/components-daisy/typography';
import { ref } from 'vue';
import { Icon } from '~/components-daisy/icons';

type Props = {
  type: string;
  text: string;
  iconName?: string;
  size?: string;
  height?: string;
};

const props = withDefaults(defineProps<Props>(), {
  iconName: '',
  size: 'medium',
  height: 'large',
});

const color = ref();

// The type will be 'error', 'info' or 'valid' for now.
// Possible to add new ones

const colorType = () => {
  if (props.type === 'error') {
    color.value = 'banner--error';
  } else if (props.type === 'info') {
    color.value = 'banner--info';
  } else if (props.type === 'valid') {
    color.value = 'banner--valid';
  } else {
    color.value = 'banner--info';
  }
  return color.value;
};

const iconColor = computed(() => {
  if (props.type === 'error') {
    return 'var(--color-red-800)';
  } else if (props.type === 'info') {
    return 'var(--color-blue-800)';
  } else if (props.type === 'valid') {
    return 'var(--color-primary-800)';
  }
});
</script>

<style lang="postcss" module>
.banner {
  justify-content: center;
  border-radius: var(--border-radius-200);
  box-shadow: var(--shadow-200);
  display: flex;
  margin-left: auto;
  margin-right: auto;
  align-items: center;
  gap: var(--space-200);

  &__width {
    &--small {
      width: 50%;
    }
    &--medium {
      width: 75%;
      @media (min-width: 1300px) {
        width: 50%;
      }
    }
    &--large {
      width: 95%;
    }
  }

  &__height {
    &--small {
      padding: var(--space-100) var(--space-100);
    }
    &--medium {
      padding: var(--space-300) var(--space-100);
    }
    &--large {
      padding: var(--space-500) var(--space-100);
    }
  }

  &--error {
    color: var(--color-red-800);
    background-color: var(--color-red-100);
    border: 1px solid var(--color-red-800);
  }
  &--info {
    color: var(--color-blue-800);
    background-color: var(--color-blue-200);
    border: 1px solid var(--color-blue-800);
  }
  &--valid {
    color: var(--color-primary-800);
    background-color: var(--color-primary-200);
    border: 1px solid var(--color-primary-800);
  }
}

.center {
  text-align: center;
  white-space: break-spaces;
  display: flex;
  justify-content: center;
  flex: 1;
}

.icon {
  width: 30px;
  height: 30px;
  border: 2px solid;
  border-radius: 50%;
  padding: var(--space-50);
}
</style>
